import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LPLogoWName } from "../../assets/index";
import { useUserLoginMutation } from "./apiSlice";
import { Tokens } from "@Constants/common";
import LocalStorage from "@Utils/storage";
import { displayToast } from '../../utils/toast';
import { ROUTES } from "@Constants/routes";
import { setUser } from "@Pages/Profile/profileSlice";
import { RootState, useAppDispatch, useAppSelector } from "@Store/store";
import "./styles"
import styles from "./styles";
import { AnalyticsParamBuilder, OnTextBlurAnalytics } from "@Utils/common";
import posthog from "posthog-js";


const COMPONENT = 'login'
const Login = () => {

  const { user } = useAppSelector((state: RootState) => state.profile);

  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')

  const navigate = useNavigate();

  const dispatch = useAppDispatch();


  useEffect(() => {
    if (user?.user_id) {
      navigate(ROUTES.DASHBOARD)
    }
  }, [user])



  const [userLogin, { data: userLoginData, error: userLoginErr, isLoading: userLoginLoading }] = useUserLoginMutation();

  // const userLogin

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e?.target?.name == 'email') setEmail(e.target.value);
    if (e?.target?.name == 'password') setPassword(e.target.value);
  };

  const onSubmitClick = (e: any) => {
    e.preventDefault()
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "login_button",
    }));
    if (email?.length > 0 && password.length > 0)
      userLogin({ email, password });
  }

  useEffect(() => {
    document.title = "LinkPlease - Login";
  }, []);

  useEffect(() => {
    if (userLoginData) {
      posthog.capture("api_response", AnalyticsParamBuilder({
        kingdom: COMPONENT,
        phylum: "user_login",
        classValue: "success",
        str_value: JSON.stringify(userLoginData)
      }));
      if (!userLoginData.user?.is_enterprise){
        posthog.capture("api_response", AnalyticsParamBuilder({
          kingdom: COMPONENT,
          phylum: "user_login",
          classValue: "error",
          genus: "not_enterprise",
          str_value: JSON.stringify(userLoginData)
        }));
        displayToast('error', 'Invalid account!')
        return
      }
      displayToast('success', 'Login Successful')
      LocalStorage.setItem(Tokens.ACCESS_TOKEN, userLoginData.data.user_access_token);
      LocalStorage.setItem(Tokens.REFRESH_TOKEN, userLoginData.data.refresh_user_access_token);
      dispatch(setUser(userLoginData.user));
      if (userLoginData.user.ig_ids.length > 0) navigate(ROUTES.DASHBOARD);
      else navigate(ROUTES.IG_CONNECT);

    } else if (userLoginErr) {
      posthog.capture("api_response", AnalyticsParamBuilder({
        kingdom: COMPONENT,
        phylum: "user_login",
        classValue: "error",
        str_value: JSON.stringify(userLoginErr)
      }));
      displayToast('error', userLoginErr?.data?.message || "Internal Error Occured")
    }
  }, [userLoginData, userLoginErr]);

  const OnForgetPasswordClick = () => {
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "forget_password",
    }));
    navigate(ROUTES.RESET_PASSWORD)
  }

  const OnSignUpClick = () => {
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "signup",
    }));
    // navigate(ROUTES.SIGNUP_PAGE)
    window.location.href = "https://calendar.app.google/PZkQTCeGj3kSL37L8"
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-cover bg-center bg-no-repeat bg-fixed"
      style={styles.LOGIN_CONTAINER}>
      <div className="w-[90%] max-w-[400px] flex flex-col items-center bg-white p-8 rounded-2xl">
        <div className="mb-8">
          <img src={LPLogoWName} className="w-[250px]" alt="Linkplease Logo" />
        </div>

        <div className="text-center mb-4">
          <h1 className="text-[1.2rem] font-semibold">Go Viral! ✨</h1>
        </div>

        <form onSubmit={onSubmitClick} className="w-full space-y-4">
          <div>
            <input
              type="email"
              name="email"
              id="email"
              placeholder="Login Email"
              onChange={handleChange}
              onBlur={() => OnTextBlurAnalytics(COMPONENT, 'email', email, 'email')}
              className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#7772FF] focus:border-transparent"
            />
          </div>

          <div>
            <input
              type="password"
              name="password"
              autoComplete="false"
              onChange={handleChange}
              id="password"
              placeholder="Password"
              onBlur={() => OnTextBlurAnalytics(COMPONENT, 'password', "redacted", 'password')}
              className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#7772FF] focus:border-transparent"
            />
          </div>

          <button
            type="submit"
            disabled={userLoginLoading}
            className="w-full bg-[#3535d5] text-white py-3 rounded-lg font-medium hover:bg-[#6561FF] transition-colors disabled:opacity-50"
          >
            {userLoginLoading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <div className="mt-4 text-center">
          <a
            onClick={OnForgetPasswordClick}
            className="text-[#6561FF] hover:cursor-pointer hover:underline"
          >
            Forgot password?
          </a>
        </div>

        <div className="mt-6 text-center">
          <p className="text-[#787781] text-sm">
            Get an enterprise account: {" "}
            <span
              className="text-[#6561FF] hover:cursor-pointer hover:underline"
              onClick={OnSignUpClick}
            >
              Here
            </span>
          </p>

        </div>
      </div>
    </div>
  );
};

export default Login;
